/**
 * Custom Hook for Page View Tracking
 * Automatically tracks page views when route changes
 * 
 * Author: Markus van Kempen - markus.van.kempen@gmail.com
 * Created: October 29, 2025
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';
import { logPageViewActivity } from '../utils/userActivity';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    const pageTitle = document.title;
    const pagePath = location.pathname + location.search;
    
    trackPageView(pagePath, pageTitle);
    // Registered users only (no-op without JWT)
    logPageViewActivity(pagePath, pageTitle);
  }, [location]);
};

export default usePageTracking;

